import { Store, Module, ActionContext } from "vuex";
import ListModule from "./list-module";
import ListState from "./list-state";
import Membership from "../entities/membership";
import Ajax from "../../lib/ajax";
import PageResult from "@/store/entities/page-result";

interface MembershipState extends ListState<Membership> {
  editMembership: Membership;
  permissions: Array<string>;
  treePermissions: Array<TreePermission>;
  recordList:Array<any>;
}

interface TreePermission {
  title: string;
  checked: boolean;
  expand: boolean;
  children: Array<TreePermission>;
}
class MembershipModule extends ListModule<MembershipState, any, Membership> {
  state = {
    totalCount: 0,
    currentPage: 1,
    pageSize: 10,
    list: new Array<Membership>(),
    loading: false,
    editMembership: new Membership(),
    permissions: new Array<string>(),
    treePermissions: new Array<TreePermission>(),
    recordList:new Array<any>()
  };
  actions = {
    async getAll(context: ActionContext<MembershipState, any>, payload: any) {
      context.state.loading = true;
      let reponse = await Ajax.get("/api/services/app/Membership/GetAll", {
        params: payload.data,
      });
      context.state.loading = false;
      let page = reponse.data.result as PageResult<Membership>;
      context.state.totalCount = page.totalCount;
      context.state.list = page.items;
    },
    async create(context: ActionContext<MembershipState, any>, payload: any) {
      await Ajax.post(
        "/api/services/app/Membership/CreateWithImages",
        payload.data
      );
    },
    async update(context: ActionContext<MembershipState, any>, payload: any) {
      await Ajax.put(
        "/api/services/app/Membership/UpdateWithImages",
        payload.data
      );
    },
    async delete(context: ActionContext<MembershipState, any>, payload: any) {
      await Ajax.delete(
        "/api/services/app/Membership/Delete?Id=" + payload.data.id
      );
    },
    async get(context: ActionContext<MembershipState, any>, payload: any) {
      let reponse = await Ajax.get(
        "/api/services/app/Membership/Get?Id=" + payload.id
      );
      return reponse.data.result as Membership;
    },
    async deleteImg(
      context: ActionContext<MembershipState, any>,
      payload: any
    ) {
      return await Ajax.delete(
        "/api/services/app/MembershipImage/Delete?Id=" + payload.data.id
      );
    },
    async getAllPermissions(context: ActionContext<MembershipState, any>) {
      let reponse = await Ajax.get(
        "/api/services/app/Membership/getAllPermissions"
      );
      context.state.permissions = reponse.data.result.items;
    },
    async getAllListByMembershipId(context: ActionContext<MembershipState, any>, payload: any) {
      context.state.loading = true;
      let reponse = await Ajax.get("/api/services/app/MembershipTrade/GetAllListByMembershipId", {
        params: payload.data,
      });
      context.state.loading = false;
      context.state.totalCount = reponse.data.result.length;
      context.state.recordList =  reponse.data.result;
    },
  };
  mutations = {
    setCurrentPage(state: MembershipState, page: number) {
      state.currentPage = page;
    },
    setPageSize(state: MembershipState, pagesize: number) {
      state.pageSize = pagesize;
    },
    edit(state: MembershipState, membership: Membership) {
      state.editMembership = membership;
    },
  };
}
const membershipModule = new MembershipModule();
export default membershipModule;
